export default "__VITE_ASSET__Wn5Ul9bDxsRroZeP87_N6A__"